import React from 'react';
// images
import quizCalloutImageWebp from './images/couple-picnic-at-lake.webp';
// styles
import { ExperienceCalloutStyled } from './styles';

export default () => (
  <ExperienceCalloutStyled
    assistiveText='Get started with our Annuities Quiz'
    isFullWidth
    withBGImage
    sectionId='quiz-callout-module-fixed-variable-annuities-page'
    imageUrl={quizCalloutImageWebp.toString()}
    headingText='How does an annuity work&#63; Test your knowledge.'
    buttonText='Take our quiz'
    linkUrl='/life-and-money/quiz/how-does-an-annuity-work-test-your-knowledge/'
    withHoverShadow
    moduleName='quiz-callout-module'
    moduleVariation='A'
    disableBottomPadding
    backgroundVariant='darkDefault'
    calloutBackgroundVariant='darkDefault'
    calloutThemeType='darkTheme'
    themeType='darkTheme'
    disableLazyLoad
  />
);
